 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		226: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + {"0":"1a4fc3c","1":"6407b1a","2":"f7ad0e5","3":"bb9e845","4":"33292e0","5":"6e9aa7d","6":"b0fce2e","7":"eea1076","8":"5f00e1d","9":"2465d39","10":"9ee53e6","11":"e4bf9e0","12":"7f30d5f","13":"283af99","14":"18b43b7","15":"f71fe2b","16":"55808e5","17":"ec2cc84","18":"c59fce1","19":"85859f7","20":"f00e76a","21":"82fa8ce","22":"c131ee2","23":"cd6078e","24":"e19faf2","25":"d64cf72","26":"08bff17","27":"7d82d47","28":"35fecb6","29":"37d5517","30":"2179c95","31":"9bf1369","32":"08a8906","33":"2a2b195","34":"f25aca2","35":"b683ded","36":"d591756","37":"82f4fff","38":"c2a0c1f","39":"d64a3fe","40":"64be720","41":"5d5cb15","42":"f5e797c","43":"a1e27d7","44":"99bb6fc","45":"498b437","46":"71a1426","47":"e1f740d","48":"e2cd547","49":"e6f2b22","50":"a572d7a","51":"c66a089","52":"7fb7934","53":"6d848ab","54":"aba5173","55":"de6064f","56":"c5b686c","57":"d71a755","58":"f565e59","59":"947851f","60":"70f0092","61":"41d1851","62":"208f290","63":"5fb3318","64":"208ceac","65":"4fb008a","66":"765f4bf","67":"38fb530","68":"1c9a181","69":"32157a3","70":"a07ec7d","71":"0c3cc23","72":"245d4a2","73":"38ef4d6","74":"ea4f391","75":"86f4251","76":"43474c2","77":"3bb63bc","78":"cff2514","79":"1615eb1","80":"b216298","81":"5d37978","82":"66bd03b","83":"66b20a9","84":"4c92376","85":"65084ec","86":"8071e7e","87":"a90b517","88":"5a28af3","89":"2f5998d","90":"344147f","91":"30c20b9","92":"e7d90a3","93":"a239dbe","94":"f2a3915","95":"1760d98","96":"6b94dea","97":"497d832","98":"9c5fd5c","99":"8a6d5da","100":"13b3764","101":"57009c9","102":"2edcb11","103":"248c69d","104":"1e24547","105":"326e1f1","106":"2371a71","107":"81aa9b8","108":"875b207","109":"7627d03","110":"6883c5b","111":"581a981","112":"3d7fd39","115":"684ca93","116":"2f3ac9b","117":"6a2481b","118":"5eb3bee","119":"62dee87","120":"a924819","121":"130763f","122":"dfda0ab","123":"dd43578","124":"856bd85","125":"6aee6e1","126":"9d0ba5f","127":"3b2d346","128":"c0786c4","129":"c689609","130":"634bb0f","131":"dadeb05","132":"7219d2c","133":"a78a140","134":"7023fd9","135":"cc5633b","136":"cc04e69","137":"82da3e5","138":"b890d73","139":"3a57787","140":"4b45ff5","141":"8672b46","142":"2dabcc5","143":"e1ad939","144":"d3b5e9a","145":"177e5ad","146":"eaa97bd","147":"cc5071b","148":"97dbc03","149":"83b4ed5","150":"dad39ed","151":"76608a2","152":"624e803","153":"ba7a3ad","154":"17a9e89","155":"a59a3b7","156":"6d344ca","157":"1426a10","158":"034703a","159":"fae515b","160":"7840651","161":"a07db87","162":"72fb9eb","163":"7b1c01c","164":"94d3e95","165":"c3b7ccc","166":"5bb2f8a","167":"524c149","168":"05a6400","169":"47330c4","170":"11eacde","171":"7674087","172":"6915c8a","173":"6d545bf","174":"0077b89","175":"4a256d8","176":"75a5956","177":"127f2ad","178":"a11f4df","179":"98dc6fb","180":"cf1b0d7","181":"1ed8cb3","182":"36abf4d","183":"94c5fda","184":"eeefa21","185":"7473159","186":"9c52ae9","187":"846bceb","188":"7abf565","189":"fb99456","190":"c1c2550","191":"c8e959b","192":"f6bc5a7","193":"c4b9fa5","194":"5add856","195":"c54a16b","196":"f30d150","197":"1a1851e","198":"a7159d6","199":"dacfcd6","200":"47d8a75","201":"cfcf317","202":"4d3c33f","203":"c234794","204":"d7c8973","205":"4b89284","206":"91c06dd","207":"5f99fe6","208":"4cbeb09","209":"b4a7fa2","210":"a08d287","211":"910bfcb","212":"6dafddd","213":"070971e","214":"e7f873a","215":"3fc77d2","216":"7cc50d2","217":"f1c2c51","218":"de15e2f","219":"74220f7","220":"36c636a","221":"0212b5b","222":"3f539cf","223":"3b64d6f","224":"b4ef36c","225":"11d59bb","228":"add7778","229":"5e03177","230":"197f6a8","231":"7849bdc","232":"c44b51a","233":"57c0f91","234":"61607d1","235":"9abb80b","236":"6958f92","237":"ea9c428","238":"631de47","239":"784bf99","240":"a77f080","241":"6cdd862","242":"e03b061","243":"504810c","244":"2b56656","245":"616e899","246":"b0383b3","247":"498dfd7","248":"ef78eec","249":"4d989f9","250":"674a3d1","251":"8027a49","252":"899ea14","253":"576f685","254":"179ed5b","255":"52d4a05","256":"99e7520","257":"06bca20","258":"aab4874","259":"d691f2b","260":"e2b20db","261":"7eebbf7","262":"105806f","263":"ce3c936","264":"9689dda","265":"80dda2a","266":"7bb0d9e","267":"ce66c57","268":"b7debf7","269":"94cdebb","270":"ffc5b00","271":"8966b64","272":"959b2ac","273":"971c7fd","274":"c4e9d5d","275":"51ec348","276":"4158ddb","277":"3df8e1f","278":"2220a68","279":"c8a0dfe","280":"5faf09d","281":"654f2a4","282":"d04cb42","283":"3a4a8b2","284":"512b925","285":"7e3addf","286":"c387e01","287":"f7d7c4f","288":"fd16680","289":"c1467e0","290":"6e1750d","291":"cf6a163","292":"9af99dc","293":"71b68db","294":"894c155","295":"3579008","296":"7990e6f","297":"e8355df","298":"14df40d","299":"a6ae2ca","300":"a5a454a","301":"fe884fb","302":"cd70d54","303":"d952c02","304":"de798b5","305":"693055c","306":"cc46799","307":"6debb06","308":"42ce64f","309":"25ba361","310":"d62427d","311":"76eb234","312":"9b516d7","313":"f95191d","314":"5d18b91","315":"e8ac704","316":"671fe17","317":"c9fde33","318":"91605ee","319":"d9be164","320":"5fc415e","321":"66fddb7","322":"b6f60d0","323":"235e590","324":"9419304","325":"a977929","326":"7d543ab","327":"2e14690","328":"76068f5","329":"4e1336c","330":"045ad46","331":"01cc5b6","332":"5c984cf","333":"28078a8","334":"aedfe9e","335":"0a93675","336":"684b6ba","337":"d15ea15","338":"66a05a6","339":"bcc28cf"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://d1mf56q6wc1y19.cloudfront.net/channels2022/220519/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
